import React, { useEffect } from 'react';
import { logScreen } from 'core/analytics';

export const SurveyFinished: React.FunctionComponent = () => {
  useEffect(() => {
    logScreen('FINISHED');
  }, []);
  return <div>Thank you for filling in this survey.</div>;
};
